import React from 'react';
import GlobalStyle from './assets/global/globalStyles';
import { useDispatch } from 'react-redux';
import { autoLogin } from './store/user';
import Popup from './components/Popup';
import Routes from './routes/';

export default function App() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(autoLogin());
  }, [dispatch]);

  return (
    <>
      <GlobalStyle />
      <Popup />
      <Routes />
    </>
  );
}
